<span class="only-grid-total-container">
    <span class="only-grid-total">
        <ng-content></ng-content>
    </span>
</span>